// eslint-disable-next-line
import React, { useEffect, useState } from 'react';

interface RenderElementsWithDelayProps {
  arrayOfValues: any[];
  delayTime: number;
}

export const RenderElementsWithDelay: React.FC<RenderElementsWithDelayProps> = ({
  arrayOfValues,
  delayTime
}) => {
  const [currentElement, setCurrentElement] = useState<string>(arrayOfValues[0]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentElement((prevElement) => {
        const currentIndex = arrayOfValues.indexOf(prevElement);
        const nextIndex = (currentIndex + 1) % arrayOfValues.length;
        return arrayOfValues[nextIndex];
      });
    }, delayTime);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{currentElement && <span>{currentElement}</span>}</>;
};
